import { useState } from 'react';
import { toast } from 'sonner';

import { getCalendlyOAuthUrl } from '@/hooks/integrations';

export const useCalendlyPopup = () => {
  const [loading, setLoading] = useState(false);

  const openCalendlyPopup = async () => {
    setLoading(true);

    try {
      const response = await getCalendlyOAuthUrl();
      if (response.url) {
        // Open popup window directly to OAuth URL (no iframe to avoid X-Frame-Options error)
        const popup = window.open(
          response.url,
          'calendly-connect',
          'width=600,height=700,scrollbars=yes,resizable=yes'
        );

        if (popup) {
          // Monitor popup for completion
          // The callback page (CalendlyCallback.jsx) handles status display and closing
          // We only need to detect when popup closes and refresh (only closes on success)
          const checkClosed = setInterval(() => {
            if (popup.closed) {
              clearInterval(checkClosed);
              setLoading(false);
              // Popup only closes on success, so refresh to get updated integration status
              window.location.reload();
            }
          }, 1000);
        } else {
          toast.error('Popup blocked. Please allow popups for this site.');
          setLoading(false);
        }
      } else {
        console.error('No OAuth URL received from backend.');
        toast.error('Failed to get Calendly connection URL');
        setLoading(false);
      }
    } catch (error) {
      console.error('Calendly connection error:', error);
      toast.error('Failed to connect Calendly. Please try again.');
      setLoading(false);
    }
  };

  return { openCalendlyPopup, loading };
};
